import { Injectable } from '@angular/core';
import { AbstractDialogService } from '@examdojo/core/dialog';
import { SkipQuestionDialogComponent } from './skip-question-dialog.component';

export const SKIP_QUESTION_DIALOG_ID = 'skip-question-dialog';

@Injectable()
export class SkipQuestionDialogService extends AbstractDialogService<void, boolean> {
  readonly id = SKIP_QUESTION_DIALOG_ID;
  protected readonly component = SkipQuestionDialogComponent;

  protected override readonly options = {
    cssClass: 'skip-question-dialog auto-height action-sheet-on-mobile',
  };

  protected override readonly dismissOnBreakpointChange = true;
}
